module.exports = __webpack_public_path__ + "assets/img/terminalPic5_app.ff943444.png";